/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
const onLoad = () =>
  new Promise((resolve, reject) => {
    if (document.readyState === 'complete') return resolve();

    const removeListeners = () => {
      window.removeEventListener('error', err);
      window.removeEventListener('load', ready);
    };

    const err = (e) => {
      removeListeners();
      return reject(e);
    };

    const ready = (e) => {
      removeListeners();
      return resolve(e);
    };

    window.addEventListener('error', err);
    window.addEventListener('load', ready);
  });

export default onLoad;
